import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../store/root-reducer';
import OAuthButtons from './oauth-buttons';
import { getOAuthRedirectUrlRequest } from './extra-actions';
import { OAuthMethod } from './types';
import { ActionForAuthentication, OAuthPayload } from '../../types';
import { resetGetOAuthRedirectUrlRequest } from './oauth-slice';

const mapStateToProps = (state: RootState) => ({
  getOAuthRedirectUrlRequestStatus:
    state.oauth.getOAuthRedirectUrlRequest.status,
  getOAuthRedirectUrlRequestError: state.oauth.getOAuthRedirectUrlRequest.error,
  authUrl: state.oauth.authUrl,
});

const mapDispatchToProps = {
  getOAuthRedirectUrl: (method: OAuthMethod, payload: OAuthPayload) =>
    getOAuthRedirectUrlRequest({ method, payload }),
  resetGetOAuthRedirectUrlRequest: () => resetGetOAuthRedirectUrlRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  type?: ActionForAuthentication;
  className?: string;
  email?: string;
  userId?: number;
};

export default connector(OAuthButtons);
